import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource/geist-sans/400.css';
import '@fontsource/geist-sans/500.css';
import '@fontsource/geist-sans/600.css';
import '@fontsource/geist-sans/700.css';
import './index.css';  // Import the Tailwind CSS file
import App from './App';

// Suppress benign "ResizeObserver loop" error from CRA's error overlay.
// MDEditor triggers this during layout shifts (sidebar open/close, re-renders).
// CRA's overlay registers in the bubble phase, so a capture-phase listener
// that stops propagation prevents it from reaching the overlay.
window.addEventListener('error', (e) => {
  if (e.message?.includes?.('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
